var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6737 9.32561L6.01174 41.6467C5.67464 42.2304 5.49713 42.8925 5.49707 43.5665C5.49701 44.2406 5.67439 44.9027 6.01138 45.4865C6.34837 46.0702 6.8331 46.5549 7.41683 46.8919C8.00056 47.2289 8.66273 47.4063 9.33675 47.4062H46.6576C47.3317 47.4063 47.9938 47.2289 48.5775 46.8919C49.1613 46.5549 49.646 46.0702 49.983 45.4865C50.32 44.9027 50.4974 44.2406 50.4973 43.5665C50.4972 42.8925 50.3197 42.2304 49.9826 41.6467L31.3227 9.32561C30.9858 8.74205 30.5012 8.25746 29.9176 7.92054C29.334 7.58362 28.672 7.40625 27.9982 7.40625C27.3243 7.40625 26.6624 7.58362 26.0788 7.92054C25.4952 8.25746 25.0106 8.74205 24.6737 9.32561Z",
    fill: "#FFDD28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2404 19.2949H27.7536C26.5551 19.2949 25.5835 20.2665 25.5835 21.465V31.8377C25.5835 33.0362 26.5551 34.0078 27.7536 34.0078H28.2404C29.4389 34.0078 30.4105 33.0362 30.4105 31.8377V21.465C30.4105 20.2665 29.4389 19.2949 28.2404 19.2949Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.997 42.2352C29.3299 42.2352 30.4105 41.1546 30.4105 39.8217C30.4105 38.4888 29.3299 37.4082 27.997 37.4082C26.6641 37.4082 25.5835 38.4888 25.5835 39.8217C25.5835 41.1546 26.6641 42.2352 27.997 42.2352Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningImg);
export default __webpack_public_path__ + "static/media/warning-img.f91de848637d75094f0e0b6da21b8af3.svg";
export { ForwardRef as ReactComponent };